<template>
  <div id="pmlst-error">
    <div class="pmlst-error-wrapper">
      <p><slot>An error has occurred, please try again later.</slot></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error-screen'
}
</script>
